// extracted by mini-css-extract-plugin
export default {"no-padding":"UxisgmSVAniHO2h","list-wrapper":"Y0UKjmcQMZ44hXJ","with-footer":"T2SvuzfmQm7qesK","footer":"PSaozG3V6VX5Ymy"};